__turbopack_context__.v({
  "fixedImage": "FixedPlate-module__ihoNBq__fixedImage",
  "root": "FixedPlate-module__ihoNBq__root",
});
